import _get from 'lodash/get'
export const stringify = JSON.stringify

export const isProduction = (): boolean => {
  return !(!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
}

export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV && process.env.NODE_ENV === 'development'
}

export const absoluteUrl = (): { protocol: string; host?: string; origin: string } => {
  let protocol = 'https:'
  const host: string | undefined = _get(window, 'location.host', undefined)
  if (host && host.indexOf('localhost') > -1) protocol = 'http:'

  return {
    protocol: protocol,
    host: host,
    origin: protocol + '//' + host,
  }
}

export const getHost = (): string | undefined => {
  const location = absoluteUrl()
  return _get(location, 'host', undefined)
}

export const getOrigin = (): string | undefined => {
  const location = absoluteUrl()
  return _get(location, 'origin', undefined)
}

export const getVars = (): {
  debug?: string
  apiUrl?: string
  clientId?: string
  apiTimeout?: string
  googleApiKey?: string
  readonly NODE_ENV: 'development' | 'production' | 'test'
} & Record<string, string | undefined> => {
  const {
    NODE_ENV = 'development',
    REACT_APP_DEBUG: debug,
    REACT_APP_API_URL: apiUrl,
    REACT_APP_CLIENT_ID: clientId,
    REACT_APP_API_TIMEOUT: apiTimeout,
    REACT_APP_GOOGLE_API_KEY: googleApiKey,
  } = process.env
  return { NODE_ENV, apiUrl, apiTimeout, clientId, googleApiKey, debug }
}

export const redirectTo = (href: string): void => {
  if (href) window.location.href = href
}

export const localTimeZone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone

export const localTimeZoneOffset = (): number => new Date().getTimezoneOffset()

export const toBase64 = (str: string): string => window.btoa(str)

export const sleep = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms))
